import React from 'react';
import {useRecoilState, useRecoilValue} from 'recoil';
import FeedbackDialog from '../../../../common/dialogs/FeedbackDialog';
import NonLoggedInUserDialog from '../../../../common/dialogs/NonLoggedInUserDialog';
import {
  bidmiiProForceUpgradeOpenState,
  directQuoteDialogOpenState,
  feedbackDialogOpenState,
  insuranceDialogOpenState,
  nonLoggedInUserDialogOpenState,
  restrictedContentWarningOpenState,
  supportPopupOpenState,
} from '../../../../recoil/dialogs/DialogsRecoil';
import DirectQuoteDialog from '../../components/DirectQuoteDialog';
import RestrictedContentWarningDialog from '../../../../common/dialogs/RestrictedContentWarningDialog';
import {
  LazyInsuranceQualifications,
  LazySupportPopup,
} from '../../../../common/LazyLoader';
import ProUpgradePopup from '../../../../common/dialogs/ProUpgradePopup';

interface IProps {}
export const Dialogs: React.FC<IProps> = (_props) => {
  const [directQuoteDialogOpen, setDirectQuoteDialogOpen] = useRecoilState(
    directQuoteDialogOpenState,
  );
  const [nonLoggedInUserDialogOpen, setNonLoggedInUserDialogOpen] =
    useRecoilState(nonLoggedInUserDialogOpenState);

  const [feedbackDialogOpen, setFeedbackDialogOpen] = useRecoilState(
    feedbackDialogOpenState,
  );
  const [supportPopupOpen, setSupportPopupOpen] = useRecoilState(
    supportPopupOpenState,
  );
  const [insuranceDialogOpen, setInsuranceDialogOpen] = useRecoilState(
    insuranceDialogOpenState,
  );
  const [restrictedContentWarningOpen, setRestrictedContentWarningOpen] =
    useRecoilState(restrictedContentWarningOpenState);
  const bidmiiProForceUpgradeOpen = useRecoilValue(
    bidmiiProForceUpgradeOpenState,
  );

  return (
    <>
      {directQuoteDialogOpen && (
        <DirectQuoteDialog
          open={directQuoteDialogOpen}
          toggleDirectQuoteDialog={() =>
            setDirectQuoteDialogOpen(!directQuoteDialogOpen)
          }
        />
      )}

      <NonLoggedInUserDialog
        open={nonLoggedInUserDialogOpen}
        handleClose={() => setNonLoggedInUserDialogOpen(false)}
      />

      {feedbackDialogOpen ? (
        <FeedbackDialog handleClose={() => setFeedbackDialogOpen(false)} />
      ) : null}

      {supportPopupOpen ? (
        <LazySupportPopup
          open={supportPopupOpen}
          handleClose={() => setSupportPopupOpen(false)}
        />
      ) : null}

      {insuranceDialogOpen ? (
        <LazyInsuranceQualifications
          handleClose={() => setInsuranceDialogOpen(false)}
        />
      ) : null}

      <RestrictedContentWarningDialog
        open={restrictedContentWarningOpen}
        handleClose={() => setRestrictedContentWarningOpen(false)}
      />

      {bidmiiProForceUpgradeOpen && <ProUpgradePopup />}
    </>
  );
};
